import { red, green, amber } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";


// primary?: PaletteColorOptions;
//   secondary?: PaletteColorOptions;
//   error?: PaletteColorOptions;
//   warning?: PaletteColorOptions;
//   info?: PaletteColorOptions;
//   success?: PaletteColorOptions;
//   mode?: PaletteMode;
//   tonalOffset?: PaletteTonalOffset;
//   contrastThreshold?: number;
//   common?: Partial<CommonColors>;
//   grey?: ColorPartial;
//   text?: Partial<TypeText>;
//   divider?: string;
//   action?: Partial<TypeAction>;
// background ?: Partial<TypeBackground>;
  
export const appTheme = createTheme({
  palette: {
    mode: "dark",
    primary: green,
    secondary: amber,
    background: {
      default: "#06080b",
      paper: "#15181d",
    },
    text: {
      primary: "#f3f5f7",
      secondary: "rgba(243,245,247,0.72)",
    },
    divider: "rgba(255,255,255,0.12)",
    error: red,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: "#171b21",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 10,
        },
      },
    },
  },
});
